export const CLUSTER_MARKER_ICON_SIZE = 35;
export const CLUSTER_MARKER_ANCHOR = CLUSTER_MARKER_ICON_SIZE / 2;
